import type { UserDetails, PasswordData } from "../types/account-details"

export const ACCOUNT_CONSTANTS = {
  VALIDATION: {
    MIN_PASSWORD_LENGTH: 8,
    MAX_FILE_SIZE: 5 * 1024 * 1024, // 5MB
  },
  MESSAGES: {
    NO_CHANGES: "No changes to save",
    FILE_TOO_LARGE: "File size must be less than 5MB",
    INVALID_FILE_TYPE: "Please select a valid image file",
    EMAIL_READONLY: "Email cannot be changed",
    PASSWORD_HINT: "Must be at least 8 characters long",
    PHOTO_HINT: "Upload a profile photo. Max size: 5MB. Supported formats: JPG, PNG, GIF",
  },
  SUCCESS_MESSAGES: {
    PHOTO_UPDATED: "Profile photo updated successfully!",
    PASSWORD_CHANGED: "Password changed successfully!",
    DETAILS_UPDATED: "Updated {count} field(s) successfully!",
    USER_LOADED: "User details loaded successfully!",
  },
  ERROR_MESSAGES: {
    PHOTO_UPDATE_FAILED: "Failed to update profile photo. Please try again.",
    PASSWORD_CHANGE_FAILED: "Failed to change password. Please try again.",
    DETAILS_UPDATE_FAILED: "Failed to update user details. Please try again.",
    USER_FETCH_FAILED: "Failed to load user details. Please refresh the page.",
    OLD_PASSWORD_REQUIRED: "Old password is required",
    NEW_PASSWORD_REQUIRED: "New password is required",
    CONFIRM_PASSWORD_REQUIRED: "Please confirm your new password",
    PASSWORD_TOO_SHORT: "New password must be at least 8 characters long",
    PASSWORDS_DONT_MATCH: "New passwords do not match",
    SAME_PASSWORD: "New password must be different from old password",
    INVALID_PASSWORD_FORMAT: "Password must contain uppercase, lowercase, number and special character",
  },
  API_ENDPOINTS: {
    GET_USER_DETAILS: "/api/user/details",
    UPDATE_USER_DETAILS: "/api/user/update",
    CHANGE_PASSWORD: "/api/user/change-password",
    UPDATE_PROFILE_PHOTO: "/api/user/profile-photo",
  },
} as const

// Default fallback data
export const DEFAULT_USER_DATA: UserDetails = {
  firstName: "",
  lastName: "",
  email: "",
  companyName: "",
  companySize: "",
  industry: "",
  country: "",
  state: "",
  city: "",
}

export const INITIAL_PASSWORD_DATA: PasswordData = {
  oldPassword: "",
  newPassword: "",
  confirmPassword: "",
}
